var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import * as _ from "lodash";
import MSALAuthService from "./MSALAuthService/MSALAuthService.js";
class MSALAuthenticator {
  static get instance() {
    this._instance = this._instance || new this();
    return this._instance;
  }
  getMiddleware(tokenParameters) {
    return (settings, next) => __async(this, null, function* () {
      yield this.applySettings(settings, tokenParameters);
      return next(settings);
    });
  }
  applySettings(settings, tokenParameters) {
    return __async(this, null, function* () {
      const token = yield MSALAuthService.getToken(tokenParameters);
      settings = _.merge(settings, { headers: { Authorization: `Bearer ${token}` } });
      return settings;
    });
  }
}
__publicField(MSALAuthenticator, "_instance");
export {
  MSALAuthenticator
};
//# sourceMappingURL=MSALAuthenticator.js.map
